import { handleActions } from 'redux-actions';

import {
  GET_CATEGORIES,
  GET_MODULES,
} from './constants';

const initialState = {
  modules: [],
  categories: [],
};

function getModules(state, { payload }) {
  return {
    ...state,
    modules: payload,
  };
}

function getCategories(state, { payload }) {
  return {
    ...state,
    categories: payload,
  };
}

export default handleActions({
  [GET_MODULES]: getModules,
  [GET_CATEGORIES]: getCategories,
}, initialState);



// WEBPACK FOOTER //
// ./src/routes/Admin/reducer.ts